import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

interface Parameter {
    ReturnReason: string;
    LineId: string;
}

type HandlerType = Handler<Parameter>;

export const DispatchChangeRmaReasons: HandlerType = ({ parameter: { ReturnReason, LineId }, dispatch }) => {
    const typedDispatch: any = dispatch;
    typedDispatch({
        type: "Data/RmaRequest/ChangeRmaReasons",
        LineId,
        ReturnReason,
    });
};

export const chain = [DispatchChangeRmaReasons];

const changeRmaReasons = createHandlerChainRunner(chain, "ChangeRmaReasons");
export default changeRmaReasons;
